import { CommonModule } from '@angular/common';
// import { UploadPublicationComponent } from './../components/business-modal/additional-public-library/modal/upload-publication/upload-publication.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule, MatSliderModule, MatTabsModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { TooltipModule } from 'ng2-tooltip-directive';
import { BsDropdownModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TimeAgoPipe } from 'time-ago-pipe';
import { SelectAdvertisementTypeComponent } from '../components/advertisement/select-advertisement-type/select-advertisement-type.component';
import { AudioNotPublishedComponent } from '../components/all-modals/audio-not-published/audio-not-published.component';
import { AudioNotUploadedComponent } from '../components/all-modals/audio-not-uploaded/audio-not-uploaded.component';
import { AudioPublishedComponent } from '../components/all-modals/audio-published/audio-published.component';
import { AudioUploadedComponent } from '../components/all-modals/audio-uploaded/audio-uploaded.component';
import { ConnectionRequestFailedComponent } from '../components/all-modals/connection-request-failed/connection-request-failed.component';
import { ConnectionRequestSentComponent } from '../components/all-modals/connection-request-sent/connection-request-sent.component';
import { ErrorMessageComponent } from '../components/all-modals/error-message/error-message.component';
import { PaymentDeclinedComponent } from '../components/all-modals/payment-declined/payment-declined.component';
import { PublicationNotPublishedComponent } from '../components/all-modals/publication-not-published/publication-not-published.component';
import { PublicationNotUploadedComponent } from '../components/all-modals/publication-not-uploaded/publication-not-uploaded.component';
import { PublicationPublishedComponent } from '../components/all-modals/publication-published/publication-published.component';
import { PublicationUploadedComponent } from '../components/all-modals/publication-uploaded/publication-uploaded.component';
import { SuccessMessageComponent } from '../components/all-modals/success-message/success-message.component';
import { TestimonialFailureComponent } from '../components/all-modals/testimonial-failure/testimonial-failure.component';
import { TestimonialSuccessComponent } from '../components/all-modals/testimonial-success/testimonial-success.component';
import { TokenDeclinedComponent } from '../components/all-modals/token-declined/token-declined.component';
import { VideoNotPublishedComponent } from '../components/all-modals/video-not-published/video-not-published.component';
import { VideoNotUploadedComponent } from '../components/all-modals/video-not-uploaded/video-not-uploaded.component';
import { VideoPublishedComponent } from '../components/all-modals/video-published/video-published.component';
import { VideoUploadedComponent } from '../components/all-modals/video-uploaded/video-uploaded.component';
import { AddPublicLibraryModalComponent } from '../components/business-modal/additional-public-library/modal/add-public-library-modal/add-public-library-modal.component';
import { QrCodeModalComponent } from '../components/business-modal/additional-public-library/modal/qr-code-modal/qr-code-modal.component';
import { SettingAdditionalPublicLibraryComponent } from '../components/business-modal/additional-public-library/modal/setting-additional-public-library/setting-additional-public-library.component';
import { AudioPreviewComponent } from '../components/material-detail/audio-preview/audio-preview.component';
import { GiftPublicationModalComponent } from '../components/material-detail/gift-modal/gift-modal.component';
import { PublicationPreviewComponent } from '../components/material-detail/publication-preview/publication-preview.component';
import { VideoPreviewComponent } from '../components/material-detail/video-preview/video-preview.component';
import { PlaylistDetailModalComponent } from '../components/private-library/playlist-detail-modal/playlist-detail-modal.component';
import { PublishModalComponent } from '../components/private-library/publish-modal/publish-modal.component';
import { RemoveContent } from '../components/private-library/remove-content/remove-content.component';
import { ShareModalComponent } from '../components/private-library/share-modal/share-modal.component';
import { AllConnectionModalComponent } from '../components/profile/all-connection-modal/all-connection-modal.component';
import { AllRequestModalComponent } from '../components/profile/all-request-modal/all-request-modal.component';
import { ConnectionCancelModalComponent } from '../components/profile/connection-cancel-modal/connection-cancel-modal.component';
import { ConnectionConfirmationModalComponent } from '../components/profile/connection-confirmation-modal/connection-confirmation-modal.component';
import { EditProfileComponent } from '../components/profile/edit-profile/edit-profile.component';
import { ReportConnectionModalComponent } from '../components/profile/report-connection-modal/report-connection-modal.component';
import { FilterComponent } from '../components/search/filter/filter.component';
import { BlocklistComponent } from '../components/settings/block-list-modal/block-list.component';
import { RequestSentComponent } from '../components/settings/request-sent/request-sent.component';
import { ConfirmModal } from '../components/supplementary-accounts/cancel-subscription/confirm-modal.component';
import { EditSupplementaryAccountComponent } from '../components/supplementary-accounts/edit-supplementary-account/edit-supplementary-account.component';
import { SettingSupplementaryAccountComponent } from '../components/supplementary-accounts/setting-supplementary-account/setting-supplementary-account.component';
import { EnterMobileComponent } from '../components/wallet/enter-mobile/enter-mobile.component';
import { TokensAddedComponent } from '../components/wallet/tokens-added/tokens-added.component';
import { TokensGiftedComponent } from '../components/wallet/tokens-gifted/tokens-gifted.component';
import { TransferTokensComponent } from '../components/wallet/transfer-tokens/transfer-tokens.component';
import { UploadSpaceModalComponent } from '../components/wipod/upload-publication/upload-space-modal/upload-space-modal.component';
import { AdvertisementAddedComponent } from './../components/all-modals/advertisement-added/advertisement-added.component';
import { AudioPreviewWrapperComponent } from './../components/material-detail/audio-preview-wrapper/audio-preview-wrapper.component';
import { ImagePreviewComponent } from './../components/material-detail/image-preview/image-preview.component';
import { PublicationPreviewWrapperComponent } from './../components/material-detail/publication-preview-wrapper/publication-preview-wrapper.component';
import { VideoPreviewWrapperComponent } from './../components/material-detail/video-preview-wrapper/video-preview-wrapper.component';
import { UploadPublicationComponent } from './../components/wipod/upload-publication/upload-publication.component';
import { AudioPlayerComponent } from './components/audio-player/audio-player.component';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { LibraryComponent } from './components/library/library.component';
import { MusicComponent } from './components/music/music.component';
import { PhoneNumberComponent } from './components/phone-number/phone-number.component';
import { PlaceAutocompleteComponent } from './components/place-autocomplete/place-autocomplete.component';
import { PublicationComponent } from './components/publication/publication.component';
import { SuggestedContentComponent } from './components/suggested-content/suggested-content.component';
import { UploadImageWarningModalComponent } from './components/upload-image-warning-modal/upload-image-warning-modal.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { VideoComponent } from './components/video/video.component';
import { DragDirective } from './directives/dragDrop.directive';
import { LandingFooterComponent, LandingHeaderComponent, LandingLayoutComponent } from './landing-layout';
import { ComingSoonComponent } from './landing-layout/landing-footer/coming-soon/coming-soon.component';
// import { ContactComponent } from './landing-layout/landing-footer/contact/contact.component';
import { HeaderComponent } from './logged-layout';
import { SidebarComponent } from './logged-layout/sidebar/sidebar.component';
import { SuggestedConnectionComponent } from './logged-layout/suggested-connection/suggested-connection.component';
import { InterestsComponent } from './modals/interests/interests.component';
import { RequestVarificationComponent } from './modals/interests/request-varification/request-varification.component';
import { DayAgoPipe } from './pipes/day-ago.pipe';
import { EllipsesPipe } from './pipes/ellipsis.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ReversePipe } from './pipes/invert-repeat';
import { Nl2brPipe } from './pipes/nl2br.pipe';
import { specialPipe } from './pipes/special.pipe';
import { PackagePlaylistListComponent } from './components/package-playlist-list/package-playlist-list.component';
import { PlanTermsModalComponent } from '../components/subscription-plans/plan-terms-modal/plan-terms-modal.component';
import { CancelSubscriptionComponent } from '../components/subscription-plans/cancel-subscription/cancel-subscription.component';
import { AdditionalPublicLibraryHomeComponent } from '../components/business-modal/additional-public-library/additional-public-library-home.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DistributeContentComponent } from '../components/public-library/distribute-content/distribute-content.component';
import { ContentTypeSelectorComponent } from '../components/wipod/content-type-selector/content-type-selector.component';
import { MinuteSecondsPipe } from './pipes/minuteSeconds.pipe';
import { AdditionalLibraryConfirmationComponent } from '../components/business-modal/additional-public-library/additional-library-confirmation/additional-library-confirmation.component';
import { EmailConfirmComponent } from '../components/auth/email-confirm/email-confirm.component';
import { AcceptedRejectedGiftComponent } from '../components/all-modals/accepted-rejected-gift/accepted-rejected-gift.component';
import { UserConfirmationGeneralComponent } from './components/user-confirmation-general/user-confirmation-general.component';
import { SubscriptionUserComponent } from './components/subscription-user/subscription-user.component';
import { SubscribeComponent } from '../components/all-modals/subscribe/subscribe.component';
import { UnsubscribeComponent } from '../components/all-modals/unsubscribe/unsubscribe.component';
import { RenewSubscriptionComponent } from '../components/all-modals/renew-subscription/renew-subscription.component';
import { CollaborationComponent } from '../components/wipod/collaboration/collaboration.component';
import { InernetConnectionComponent } from '../components/all-modals/internet-connection/internet-connection.component';
import { UserFilterPipe } from './pipes/user-filter.pipe';
import { RenewContentComponent } from '../components/private-library/renew-content/renew-content.component';
import { AudioDisableComponent } from '../components/all-modals/audio-disable/audio-disable.component';
import { RemoveADPContentComponent } from '../components/private-library/remove-adp-content/remove-adp-content.component';
import { ImageviewmodalComponent } from '../components/all-modals/imageviewmodal/imageviewmodal.component';
import { ImageViewerComponent } from '../components/chats/image-viewer/image-viewer.component';
import { MaintenanceComponent } from '../components/all-modals/maintenance/maintenance.component';
import { StartupPausedComponent } from '../components/all-modals/startup-paused/startup-paused.component';
// import { CancelUploadingComponent } from '../components/all-modals/cancel-uploading/cancel-uploading.component';

@NgModule({
  declarations: [
    LibraryComponent,
    MusicComponent,
    VideoComponent,
    PublicationComponent,
    InterestsComponent,
    SidebarComponent,
    SuggestedConnectionComponent,
    PlaceAutocompleteComponent,
    EllipsesPipe,
    DragDirective,
    DayAgoPipe,
    ReversePipe,
    specialPipe,
    TimeAgoPipe,
    Nl2brPipe,
    FilterPipe,
    UserFilterPipe,
    MinuteSecondsPipe,
    FilterComponent,
    TransferTokensComponent,
    PublishModalComponent,
    RequestVarificationComponent,
    RequestSentComponent,
    TokensAddedComponent,
    TokenDeclinedComponent,
    MaintenanceComponent,
    StartupPausedComponent,
    TokensGiftedComponent,
    EnterMobileComponent,
    AllConnectionModalComponent,
    EditProfileComponent,
    ConnectionCancelModalComponent,
    ImageCropperComponent,
    UploadPublicationComponent,
    UploadImageWarningModalComponent,
    SuggestedContentComponent,
    AudioPlayerComponent,
    ComingSoonComponent,
    UploadSpaceModalComponent,
    AllRequestModalComponent,
    BlocklistComponent,
    AudioUploadedComponent,
    VideoUploadedComponent,
    AudioNotUploadedComponent,
    VideoNotUploadedComponent,
    PublicationUploadedComponent,
    PublicationNotUploadedComponent,
    AudioPublishedComponent,
    AudioNotPublishedComponent,
    AudioDisableComponent,
    ImageviewmodalComponent,
    ImageViewerComponent,
    VideoPublishedComponent,
    VideoNotPublishedComponent,
    PublicationPublishedComponent,
    PublicationNotPublishedComponent,
    ConnectionRequestSentComponent,
    ConnectionRequestFailedComponent,
    TestimonialSuccessComponent,
    TestimonialFailureComponent,
    SelectAdvertisementTypeComponent,
    AdvertisementAddedComponent,
    SuccessMessageComponent,
    InernetConnectionComponent,
    ErrorMessageComponent,
    VideoPlayerComponent,
    AudioPreviewComponent,
    VideoPreviewComponent,
    PublicationPreviewComponent,
    AudioPreviewWrapperComponent,
    ImagePreviewComponent,
    VideoPreviewWrapperComponent,
    PublicationPreviewWrapperComponent,
    RemoveContent,
    RemoveADPContentComponent,
    ConnectionConfirmationModalComponent,
    ReportConnectionModalComponent,
    PhoneNumberComponent,
    LandingLayoutComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    HeaderComponent,
    ShareModalComponent,
    PaymentDeclinedComponent,
    AddPublicLibraryModalComponent,
    QrCodeModalComponent,
    SettingAdditionalPublicLibraryComponent,
    GiftPublicationModalComponent,
    ConfirmModal,
    EditSupplementaryAccountComponent,
    SettingSupplementaryAccountComponent,
    PlaylistDetailModalComponent,
    PackagePlaylistListComponent,
    PlanTermsModalComponent,
    CancelSubscriptionComponent,
    AdditionalPublicLibraryHomeComponent,
    OnlyNumberDirective,
    DistributeContentComponent,
    ContentTypeSelectorComponent,
    AdditionalLibraryConfirmationComponent,
    EmailConfirmComponent,
    AcceptedRejectedGiftComponent,
    UserConfirmationGeneralComponent,
    SubscriptionUserComponent,
    SubscribeComponent,
    UnsubscribeComponent,
    RenewSubscriptionComponent,
    CollaborationComponent,
    RenewContentComponent,
    // CancelUploadingComponent
  ],
  imports: [
    BsDropdownModule.forRoot(),
    CommonModule,
    RouterModule,
    FormsModule,
    AngularMultiSelectModule,
    ReactiveFormsModule,
    TabsModule.forRoot(),
    Ng2SearchPipeModule,
    NgxIntlTelInputModule,
    NgbModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ImageCropperModule,
    MatSliderModule,
    MatProgressBarModule,
    CarouselModule,
    // PdfViewerModule,
    NgxExtendedPdfViewerModule,
    TooltipModule,
    NgxPaginationModule,
    MatTabsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LibraryComponent,
    MusicComponent,
    VideoComponent,
    PublicationComponent,
    SidebarComponent,
    SuggestedConnectionComponent,
    PublicationComponent,
    EllipsesPipe,
    DragDirective,
    DayAgoPipe,
    ReversePipe,
    specialPipe,
    TimeAgoPipe,
    Nl2brPipe,
    FilterPipe,
    UserFilterPipe,
    MinuteSecondsPipe,
    PlaceAutocompleteComponent,
    PublishModalComponent,
    AngularMultiSelectModule,
    SuggestedContentComponent,
    AudioPlayerComponent,
    AdvertisementAddedComponent,
    SuccessMessageComponent,
    InernetConnectionComponent,
    ErrorMessageComponent,
    VideoPlayerComponent,
    PhoneNumberComponent,
    LandingLayoutComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    HeaderComponent,
    TooltipModule,
    PackagePlaylistListComponent,
    AdditionalPublicLibraryHomeComponent,
    OnlyNumberDirective,
    MatTabsModule,
    SubscriptionUserComponent,
    RenewContentComponent,
    CarouselModule,
  ],
  entryComponents: [
    InterestsComponent,
    AudioUploadedComponent,
    FilterComponent,
    TransferTokensComponent,
    PublishModalComponent,
    RequestVarificationComponent,
    RequestSentComponent,
    TokensAddedComponent,
    TokenDeclinedComponent,
    MaintenanceComponent,
    StartupPausedComponent,
    TokensGiftedComponent,
    EnterMobileComponent,
    EditProfileComponent,
    AllConnectionModalComponent,
    ConnectionCancelModalComponent,
    ImageCropperComponent,
    UploadPublicationComponent,
    UploadImageWarningModalComponent,
    ComingSoonComponent,
    // ContactComponent,
    UploadSpaceModalComponent,
    AllRequestModalComponent,
    BlocklistComponent,
    VideoUploadedComponent,
    AudioNotUploadedComponent,
    VideoNotUploadedComponent,
    PublicationUploadedComponent,
    PublicationNotUploadedComponent,
    AudioPublishedComponent,
    AudioNotPublishedComponent,
    AudioDisableComponent,
    ImageviewmodalComponent,
    ImageViewerComponent,
    VideoPublishedComponent,
    VideoNotPublishedComponent,
    PublicationPublishedComponent,
    PublicationNotPublishedComponent,
    ConnectionRequestSentComponent,
    ConnectionRequestFailedComponent,
    TestimonialSuccessComponent,
    TestimonialFailureComponent,
    SelectAdvertisementTypeComponent,
    AdvertisementAddedComponent,
    SuccessMessageComponent,
    InernetConnectionComponent,
    ErrorMessageComponent,
    VideoPlayerComponent,
    AudioPreviewComponent,
    VideoPreviewComponent,
    PublicationPreviewComponent,
    AudioPreviewWrapperComponent,
    VideoPreviewWrapperComponent,
    ImagePreviewComponent,
    PublicationPreviewWrapperComponent,
    RemoveContent,
    RemoveADPContentComponent,
    ConnectionConfirmationModalComponent,
    ReportConnectionModalComponent,
    ShareModalComponent,
    PaymentDeclinedComponent,
    AddPublicLibraryModalComponent,
    QrCodeModalComponent,
    SettingAdditionalPublicLibraryComponent,
    GiftPublicationModalComponent,
    ConfirmModal,
    EditSupplementaryAccountComponent,
    SettingSupplementaryAccountComponent,
    PlaylistDetailModalComponent,
    PlanTermsModalComponent,
    CancelSubscriptionComponent,
    DistributeContentComponent,
    ContentTypeSelectorComponent,
    AdditionalLibraryConfirmationComponent,
    EmailConfirmComponent,
    AcceptedRejectedGiftComponent,
    UserConfirmationGeneralComponent,
    SubscribeComponent,
    UnsubscribeComponent,
    RenewSubscriptionComponent,
    CollaborationComponent,
    RenewContentComponent
  ],
  providers: [DeviceDetectorService]
})
export class SharedModule { }
